$(document).ready(function() {

    const modelsWearingSlidesCount = document.querySelectorAll('.model-are-wearing-swiper-container .swiper-slide').length;
        
    if(modelsWearingSlidesCount > 1) {
        $('.model-are-wearing-swiper-container').addClass( "enabled" );
    }

    var modelsWearingSwiper = new Swiper('.model-are-wearing-swiper-container', {
        loop: true,
        watchOverflow: true,
        navigation: {
            nextEl: '.model-are-wearing-swiper-container .swiper-button-next',
            prevEl: '.model-are-wearing-swiper-container .swiper-button-prev',
        },
    });
})

// function addToCart(variantId) {
//     var url = '/cart/add.js';
//     var data = {
//       quantity: 1, // Adjust the quantity as needed
//       id: variantId
//     };
  
//     fetch(url, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(data)
//     })
//     .then(response => response.json())
//     .then(data => {
//       // Handle the response, e.g., update the cart count or display a success message
// 			$.ajax({
// 				url: '/?section_id=cart-drawer',
// 				type: 'GET',
// 				dataType: 'html',
// 				success:function(carthtml) {
// 						$('cart-drawer').html($(carthtml).find('cart-drawer').html());
// 				}
// 			});
//       console.log(data);
//     })
//     .catch(error => {
//       console.error(error);
//     });
//   }



function addItemToCart(variant_id) {
  let cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer'),
  formData = {
    items: [
      {
        id: variant_id,
        quantity: 1
      }
    ],
    sections: cart.getSectionsToRender().map(section => section.id)
  };
  cart.setActiveElement(document.activeElement);
  const config = fetchConfig('json');
  config.headers['X-Requested-With'] = 'XMLHttpRequest',
  config.body = JSON.stringify(formData),
  fetch(`${ routes.cart_add_url }`, config).then(response => response.json()).then(
    response => {
      if (response.errors) {
        publish(
          PUB_SUB_EVENTS.cartError,
          {
            source: 'product-form',
            productVariantId: variant_id,
            errors: response.errors,
            message: response.errors
          }
        );
        let errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
        if (!errorMessageWrapper) return;
        let errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
        errorMessageWrapper.toggleAttribute('hidden', !errorMessage),
        errorMessage &&
        (errorMessage.textContent = response.errors)
      } else {
        publish(
          PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'product-form',
            productVariantId: variant_id
          }
        );
        let cartObj = {};
        Object.assign(cartObj, response.items[0]),
        Object.assign(cartObj, {
          sections: response.sections
        }),
        cart.renderContents(cartObj),
        cart.classList.remove('is-empty'),
        trapFocus(
          document.getElementById('CartDrawer'),
          document.getElementById('CartDrawer')
        )
      }
    }
  )
}

document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('.cart-drawer'); // Adjust the selector if needed

  if (cartDrawer) {
    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('is-open')) {
            // Cart drawer is open
            console.log('Cart drawer opened');
            // Do something when the cart drawer opens
          } else {
            // Cart drawer is closed
            console.log('Cart drawer closed');
            // Do something when the cart drawer closes
          }
        }
      }
    });

    observer.observe(cartDrawer, { attributes: true });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer.drawer'); // Adjust the selector if needed

  if (cartDrawer) {
    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            // Cart drawer is open
            console.log('Cart drawer opened');
            // Do something when the cart drawer opens
						
            setTimeout(() => {
              const addUpsellButtons = document.querySelectorAll('.add-upsell-to-cart');

              addUpsellButtons.forEach(button => {
                button.addEventListener('click', event => {
                  event.preventDefault(); // Prevent the default button action (e.g., form submission)
                  console.log(button.getAttribute("item_id"));
                  const variantId = button.getAttribute("item_id"); // Get the variant ID from the button's data attribute
                  addItemToCart(variantId);
                  console.log("hello world");
                });
              });
            }, 500);											
          } else {
            // Cart drawer is closed
            console.log('Cart drawer closed');
            // Do something when the cart drawer closes
          }
        }
      }
    });

    observer.observe(cartDrawer, { attributes: true });
  }
});

$(".open-pricing-modal").click(function(){
  // prevent body from scrolling
  $("body").toggleClass("modal-open");

  // make pricing modal visible
  $(".pricing-modal").toggleClass("show");

})

$(".pricing-modal").each(function(index) {
  $(this).detach().appendTo("body");
});

// initialize close modal button
$(document).on("click", ".close-modal-trigger", function(){
  $(".modal--overlay").removeClass("show");
  $(this).closest('.show').toggleClass("show");
  $("body").toggleClass("modal-open");
})

document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('summary.header__menu-item');
    
    menuItems.forEach(item => {
        item.addEventListener('click', function(event) {
            event.preventDefault();
            
            const headerDrawer = document.querySelector('header-drawer .menu-drawer-container');
            if (!headerDrawer) return;

            const menuText = this.textContent.trim().toLowerCase();
            const drawerTrigger = headerDrawer.querySelector('summary.header__icon--menu');
            const drawerSubmenuSummary = headerDrawer.querySelector(`summary[id*="HeaderDrawer-${menuText}"]`);
            
            if (drawerTrigger) {
              if (!headerDrawer.hasAttribute('open')) {
                drawerTrigger.click();                
              }
              if (drawerSubmenuSummary.getAttribute('aria-expanded') === 'false') {
                setTimeout(() => {
                  drawerSubmenuSummary.click();                    
                }, 1);
              }
            }
        });
    });
});

